module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-TI.985731f1.png";